import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_4 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_5 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_8 = { class: "p-field p-col p-col-12 p-md-6 p-lg-4" }
const _hoisted_9 = { class: "p-field p-col-12 p-sm p-md-6" }
const _hoisted_10 = { class: "card p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_11 = { class: "p-grid" }
const _hoisted_12 = { class: "p-offset-4 p-col-4 p-sm-4 p-md-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmPopup),
    _createVNode(_component_Panel, { header: "Xác nhận lịch khám bệnh" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[9] || (_cache[9] = _createElementVNode("label", null, "Họ và tên", -1)),
            _createVNode(_component_InputText, {
              id: "fullname",
              type: "text",
              modelValue: $setup.registerServiceUpdate.customerName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.registerServiceUpdate.customerName) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, "Số điện thoại", -1)),
            _createVNode(_component_InputText, {
              id: "phoneNumber",
              type: "text",
              modelValue: $setup.registerServiceUpdate.phoneNumber,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.registerServiceUpdate.phoneNumber) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("label", null, "Địa chỉ", -1)),
            _createVNode(_component_InputText, {
              id: "address",
              type: "text",
              modelValue: $setup.registerServiceUpdate.address,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.registerServiceUpdate.address) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[12] || (_cache[12] = _createElementVNode("label", null, "Tiền sử bệnh", -1)),
            _createVNode(_component_InputText, {
              id: "antecedent",
              type: "text",
              modelValue: $setup.registerServiceUpdate.antecedent,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.registerServiceUpdate.antecedent) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _cache[13] || (_cache[13] = _createElementVNode("label", null, "Dịch vụ", -1)),
            _createVNode(_component_InputText, {
              id: "service",
              type: "text",
              modelValue: $setup.registerServiceUpdate.serviceName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.registerServiceUpdate.serviceName) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Yêu cầu", -1)),
            _createVNode(_component_InputText, {
              id: "message",
              type: "text",
              modelValue: $setup.registerServiceUpdate.message,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.registerServiceUpdate.message) = $event)),
              style: {"text-align":"center"}
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, "Chọn bác sĩ khám", -1)),
            _createVNode(_component_Dropdown, {
              modelValue: $setup.registerServiceUpdate.idBacSi,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.registerServiceUpdate.idBacSi) = $event)),
              options: $setup.listDoctorExamine,
              optionLabel: "doctorName",
              optionValue: "id",
              placeholder: "Chọn bác sĩ",
              filter: true,
              style: {"height":"35px"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[16] || (_cache[16] = _createElementVNode("label", { for: "dateselect" }, "Chọn thời gian khám:", -1)),
            _createVNode(_component_Calendar, {
              id: "dateselect",
              modelValue: $setup.registerServiceUpdate.timeBooking,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.registerServiceUpdate.timeBooking) = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "1900:2050",
              minDate: $setup.minDate,
              showTime: true
            }, {
              body: _withCtx(({data}) => [
                _createTextVNode(_toDisplayString($setup.formatDateTime(data.timeBooking)), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "minDate"])
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }, null, -1)),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Button, {
                  label: "Cập nhật",
                  icon: "pi pi-check",
                  disabled: !$setup.valid(),
                  onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.update()))
                }, null, 8, ["disabled"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}